import OutboundTransactionCommissionSummaryDTO from "../../domain/finance/OutboundTransactionCommissionSummaryDTO";
import RawWsService from "../RawWsService";

const ENDPOINT_BASE = "/admin/commission/outbound-transaction/summary";

export default class OutboundTransactionCommissionSummaryService {

    static retrieve(userId) {

        let endpoint = ENDPOINT_BASE + "?user-id=" + userId;

        return RawWsService.get(endpoint, {}, 200).then(
            response => {
                let array = [];
                response.body.forEach(jsonSummary => {
                    array.push(new OutboundTransactionCommissionSummaryDTO(jsonSummary));
                });
                return {"headers": response.headers, "body": array};
            },
            response => {
                return response;
            });
    }

}